import {mapGetters} from 'vuex';

export const permissionsMixin = {

    methods: {

        ...mapGetters([
            'authUser',
        ]),

        mixinCheckPermissions(permissionsToCheck) {

            if (this.authUser() && permissionsToCheck) {
                return this.authUser().permissions.some(function (permission) {
                    const hasAllPermissions = permission.name === 'ALL';
                    const hasPermission = permissionsToCheck.some(permissionToCheck => permission.name.includes(permissionToCheck));
                    return hasAllPermissions || hasPermission;
                });

            } else {
                return true;
            }
        },

        mixinCheckPermission(permissionToCheck) {
            return this.mixinCheckPermissions([permissionToCheck]);
        },

        mixinCheckIndividualPermission(permissionToCheck) {
          if (this.authUser() && permissionToCheck) {
             const permission = this.authUser().permissions.filter((item) =>  item.name === permissionToCheck);
             if (permission.length) {
               return  true;
             } else {
               return false;
             }
          } else {
            return false;
          }

        }
    }
};
